module.exports = __webpack_public_path__ + "static/media/img_technical_01.bd0f7b2c.png";